export const normalize = (s: string) => s.toLowerCase().trim()
